






























































































































import { Component, Vue } from "vue-property-decorator";
import websocket from "../../../api/websocket";
import { UserData, RoomStatus } from "../../../api/data";
import roomStore from "@/../api/room.store";

@Component
export default class MenuMain extends Vue {
  showNameDialog = false;
  showEmailDialog = false;
  showRoomDialog = false;

  name = "not connected";
  imgUrl = "";

  providedName = "";
  providedUrl = "";

  roomName = "";
  roomPassword = "";

  rooms: RoomStatus[] = roomStore.rooms();

  created() {
    websocket.on("OwnData", this.personalDataReceived);
    websocket.register();
  }

  personalDataReceived(data) {
    const userData: UserData = data.user;
    this.name = userData.name;
    this.imgUrl =
      "https://www.gravatar.com/avatar/" + userData.gravatar_id + "?d=retro";
    this.providedName = userData.name;
    this.providedUrl = "";
  }

  setName(name) {
    websocket.setName(name);
  }

  setAvatar(email) {
    websocket.setAvatar(email);
  }

  joinRoom() {
    websocket.joinRoom(this.roomName, this.roomPassword, false);
    this.showRoomDialog = false;
    this.roomName = "";
    this.roomPassword = "";
  }

  leaveRoom(roomName: string) {
    websocket.leaveRoom(roomName);
  }
}
